import { api } from "@/lib/api";

let _configPromise = null;

export function getConfig() {
  if (!_configPromise) {
    _configPromise = api
      .get("/config/public")
      .then((r) => r.data)
      .catch(() => ({}));
  }
  return _configPromise;
}

// Wrap an outbound URL with an affiliate tag when applicable.
// Currently supports Amazon Associates via `AMAZON_ASSOCIATES_TAG`.
export function wrapAffiliate(url, cfg) {
  if (!url || !cfg) return url;
  try {
    const u = new URL(url);
    if (
      cfg.amazon_tag &&
      /(^|\.)amazon\.(com|co\.uk|ca|de|fr|it|es|com\.au|com\.mx)$/i.test(u.hostname.replace(/^www\./, ""))
    ) {
      u.searchParams.set("tag", cfg.amazon_tag);
      return u.toString();
    }
    // Skimlinks routes clicks server-side, so no URL rewrite needed —
    // the injected script handles all outbound anchors automatically.
    return url;
  } catch {
    return url;
  }
}
